import * as actions from './production/actions'
import * as mutations from './production/mutations'
import * as getters from './production/getters'

import { navProps, plannerProps } from './production/properties'

const state = {
    list: null,
    searched: 0,
    worker_history: [],
    ready_orders: [],
    ready_order_detail_list: [],
    nav: JSON.parse(JSON.stringify(navProps)),
    autocomplete_list: [],
    worker_work_status_list: [],
    process_batch_list: {
        store_id: null,
        process_list: [],
        include_mo_order: false
    },
    assignment_history: [],
    planner: JSON.parse(JSON.stringify(plannerProps)),
    group_work_order: {
        list: [],
        nav: JSON.parse(JSON.stringify(navProps))
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/production.js